/** Sunucunun kaydedilmemiş satıra verdiği boş kimlik (Guid.Empty). */
export const BOS_KIMLIK = "00000000-0000-0000-0000-000000000000";

interface Satir {
    ambarExpectedIncomeOutcomeId: string
    agreementSchemeId: string
}

/**
 * Fiyat Bul kaydından sonra Beklenen Gelir tablosuna eklenecek satırlar (09.10.2026).
 * Yanıtta seçilmeyen şablonların kaydedilmemiş aday satırları da gelir (kimlik boş); yalnız seçilen
 * şablonların gerçekten yazılan ve tabloda henüz olmayan satırları döner.
 */
export const fiyatBulYeniSatirlar = <T extends Satir>(yanitSatirlari: T[], secilenSemalar: string[], mevcutSatirIdleri: string[]): T[] =>
    yanitSatirlari.filter(x => x.ambarExpectedIncomeOutcomeId
        && x.ambarExpectedIncomeOutcomeId != BOS_KIMLIK
        && secilenSemalar.includes(x.agreementSchemeId)
        && !mevcutSatirIdleri.includes(x.ambarExpectedIncomeOutcomeId));

/**
 * Sefer Fiyat Bul (13.10.2026): sunucu ekrandaki bir satiri guncellediyse (sefer satiri, birim fiyat degismis olabilir)
 * o satirin yeni hali. Ekranda eski tutar kalirsa siparisin Kaydet'i sunucudaki yeni tutari geri yazar.
 */
export const fiyatBulGuncellenenSatirlar = <T extends Satir>(yanitSatirlari: T[], secilenSemalar: string[], mevcutSatirIdleri: string[]): T[] =>
    yanitSatirlari.filter(x => x.ambarExpectedIncomeOutcomeId
        && x.ambarExpectedIncomeOutcomeId != BOS_KIMLIK
        && secilenSemalar.includes(x.agreementSchemeId)
        && mevcutSatirIdleri.includes(x.ambarExpectedIncomeOutcomeId));
